import { render, staticRenderFns } from "./LalamoveCoupon.vue?vue&type=template&id=5097225c&scoped=true"
import script from "./LalamoveCoupon.vue?vue&type=script&lang=js"
export * from "./LalamoveCoupon.vue?vue&type=script&lang=js"
import style0 from "./LalamoveCoupon.vue?vue&type=style&index=0&id=5097225c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5097225c",
  null
  
)

export default component.exports